import script from "./VerifyBy.vue?vue&type=script&setup=true&lang=js"
export * from "./VerifyBy.vue?vue&type=script&setup=true&lang=js"

import "./VerifyBy.vue?vue&type=style&index=0&id=55253ba1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55253ba1"]])

export default __exports__